module.exports = __webpack_public_path__ + "static/media/texture-green-d.e3ef367a.png";